document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mb-pdp-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-mb-pdp-gallery-main-image]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-mb-pdp-gallery-thumb]'));
    if (!mainImg) return;

    var images = thumbs.map(function (thumb) {
      return {
        full: thumb.getAttribute('data-full'),
        full400: thumb.getAttribute('data-full-400'),
        full800: thumb.getAttribute('data-full-800'),
        full2000: thumb.getAttribute('data-full-2000'),
        alt: thumb.getAttribute('data-alt')
      };
    });

    var currentIndex = 0;
    thumbs.forEach(function (t, i) {
      if (t.getAttribute('aria-current') === 'true') currentIndex = i;
    });

    // Shared by both the thumbnail rail and the zoom lightbox's prev/next
    // arrows, so picking an image via either control keeps the other in
    // sync (e.g. closing the zoom leaves the main gallery on the same image).
    var onSelect = null;

    function selectImage(index) {
      if (!images.length) return;
      index = ((index % images.length) + images.length) % images.length;
      currentIndex = index;
      var data = images[index];

      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });

      if (data.full) mainImg.src = data.full;
      if (data.full400 && data.full800) {
        mainImg.srcset = data.full400 + ' 400w, ' + data.full800 + ' 800w, ' + data.full + ' 1200w';
      }
      if (data.alt) mainImg.alt = data.alt;
      if (data.full2000) mainImg.setAttribute('data-full', data.full2000);

      if (onSelect) onSelect(data);
    }

    // Exposed so the variant-picker click handler below (a separate
    // querySelectorAll('[data-mb-pdp-variant-picker]').forEach closure) can
    // swap the main image when the selected variant has an assigned image.
    // Takes pre-sized URLs directly (src400/src800/src1200/src2000/alt) —
    // NOT a media/image id — because a variant's assigned image
    // (variant.featured_image, a legacy Image/ProductImage) and this
    // gallery's thumbnails (product.media, MediaImage-backed) use two
    // different, non-matching id spaces even for the exact same picture,
    // so id-matching between them can never work. If one of THIS gallery's
    // own thumbnails happens to have the identical 800px URL, that thumb is
    // selected instead (via the normal selectImage path, so aria-current
    // and the zoom lightbox stay in sync); otherwise the main image is set
    // directly from the given URLs.
    gallery.mbSetImage = function (data) {
      if (!data) return;
      for (var i = 0; i < images.length; i++) {
        if (images[i].full800 && data.src800 && images[i].full800 === data.src800) {
          selectImage(i);
          return;
        }
      }
      if (data.src400) mainImg.src = data.src400;
      if (data.src400 && data.src800) {
        mainImg.srcset = data.src400 + ' 400w, ' + data.src800 + ' 800w, ' + (data.src1200 || data.src800) + ' 1200w';
      }
      if (data.alt) mainImg.alt = data.alt;
      if (data.src2000) mainImg.setAttribute('data-full', data.src2000);
      if (onSelect) {
        onSelect({ full: data.src1200 || data.src800, full400: data.src400, full800: data.src800, full2000: data.src2000, alt: data.alt });
      }
    };

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { selectImage(i); });
    });

    // Click-to-zoom lightbox: clicking the main image opens a full-size
    // view, with prev/next arrows (and ArrowLeft/ArrowRight keys) cycling
    // through every image on the product — not just the one that was
    // showing when the lightbox opened — instead of needing to close and
    // reopen it for each image.
    var zoom = document.querySelector('[data-mb-pdp-zoom]');
    if (zoom) {
      var zoomImg = zoom.querySelector('[data-mb-pdp-zoom-image]');
      var prevBtn = zoom.querySelector('[data-mb-pdp-zoom-prev]');
      var nextBtn = zoom.querySelector('[data-mb-pdp-zoom-next]');
      var lastFocused = null;

      onSelect = function (data) {
        if (!zoom.hidden) {
          zoomImg.src = data.full2000 || data.full || '';
          zoomImg.alt = data.alt || '';
        }
      };

      if (images.length < 2) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
      }

      function openZoom() {
        lastFocused = document.activeElement;
        var data = images[currentIndex];
        zoomImg.src = (data && (data.full2000 || data.full)) || mainImg.getAttribute('data-full') || mainImg.src;
        zoomImg.alt = (data && data.alt) || mainImg.alt || '';
        zoom.hidden = false;
        document.body.classList.add('mb-pdp-zoom-lock');
        zoom.querySelector('[data-mb-pdp-zoom-close]').focus();
      }

      function closeZoom() {
        zoom.hidden = true;
        zoomImg.src = '';
        document.body.classList.remove('mb-pdp-zoom-lock');
        if (lastFocused) lastFocused.focus();
      }

      gallery.querySelectorAll('[data-mb-pdp-zoom-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', openZoom);
      });

      zoom.querySelectorAll('[data-mb-pdp-zoom-close]').forEach(function (btn) {
        btn.addEventListener('click', closeZoom);
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { selectImage(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { selectImage(currentIndex + 1); });

      document.addEventListener('keydown', function (e) {
        if (zoom.hidden) return;
        if (e.key === 'Escape') closeZoom();
        if (e.key === 'ArrowLeft') selectImage(currentIndex - 1);
        if (e.key === 'ArrowRight') selectImage(currentIndex + 1);
      });
    }
  });

  document.querySelectorAll('[data-mb-pdp-qty-decrease], [data-mb-pdp-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.mb-pdp__qtyadd');
      if (!wrap) return;
      var valueEl = wrap.querySelector('[data-mb-pdp-qty-value]');
      var input = wrap.querySelector('[data-mb-pdp-qty-input]');
      if (!valueEl || !input) return;

      var current = parseInt(valueEl.textContent, 10) || 1;
      var next = btn.hasAttribute('data-mb-pdp-qty-increase') ? current + 1 : Math.max(1, current - 1);

      valueEl.textContent = next;
      input.value = next;
    });
  });

  // Real Shopify variant picker (e.g. "Qty: Single Copy/15 Copies/32
  // Copies") — swaps price/SKU/stock/add-to-cart variant id in place, no
  // page navigation. Distinct from the sibling-product selector rows,
  // which just link out to a different product.
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
    thousands = thousands === undefined ? ',' : thousands;
    decimal = decimal === undefined ? '.' : decimal;
    var negative = number < 0 ? '-' : '';
    var n = Math.abs(number).toFixed(precision);
    var parts = n.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return negative + dollars + cents;
  }

  function formatMoney(cents) {
    var format = window.MB_PDP_MONEY_FORMAT || '${{amount}}';
    var value = cents / 100;
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var formatted;
    switch (match[1]) {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      default:
        formatted = formatWithDelimiters(value, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
  }

  // Sets a button's visible label — if the button has a dedicated
  // data-mb-pdp-atc-label child (the sticky bar's button also carries an
  // icon svg), only that span's text is replaced; otherwise (the plain
  // inline Add to Cart button) the button's own textContent is set, same
  // as before.
  function setAtcButtonLabel(btn, text) {
    var label = btn.querySelector('[data-mb-pdp-atc-label]');
    if (label) {
      label.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  document.querySelectorAll('[data-mb-pdp-variant-picker]').forEach(function (picker) {
    var script = picker.querySelector('[data-mb-pdp-variants]');
    if (!script) return;

    var variants;
    try {
      variants = JSON.parse(script.textContent) || [];
    } catch (e) {
      variants = [];
    }
    if (!variants.length) return;

    var variantImages = {};
    var imagesScript = picker.querySelector('[data-mb-pdp-variant-images]');
    if (imagesScript) {
      try {
        variantImages = JSON.parse(imagesScript.textContent) || {};
      } catch (e) {
        variantImages = {};
      }
    }

    var selected = [];
    picker.querySelectorAll('[data-mb-pdp-variant-option]').forEach(function (row) {
      var pos = parseInt(row.getAttribute('data-option-position'), 10);
      var active = row.querySelector('[data-mb-pdp-variant-value].is-selected') || row.querySelector('[data-mb-pdp-variant-value]');
      selected[pos - 1] = active ? active.getAttribute('data-value') : null;
    });

    function findVariant() {
      var matches = variants.filter(function (v) {
        return v.options.length === selected.length && v.options.every(function (val, i) { return val === selected[i]; });
      });
      return matches[0] || null;
    }

    // Swaps the main gallery image to whatever image the merchant assigned
    // to this variant in Admin (variant.featured_image) — using the
    // pre-sized URLs baked into the data-mb-pdp-variant-images script tag
    // (see sections/mecca-pdp-main.liquid), not the variant's raw id,
    // since that id lives in a different id space than the gallery's own
    // media ids and can't be matched against them directly. No-ops if the
    // variant has no assigned image.
    function applyVariantImage(variant) {
      var data = variantImages[variant.id];
      if (!data) return;
      document.querySelectorAll('[data-mb-pdp-gallery]').forEach(function (gallery) {
        if (typeof gallery.mbSetImage === 'function') {
          gallery.mbSetImage(data);
        }
      });
    }

    function apply(variant) {
      document.querySelectorAll('[data-mb-pdp-variant-id-input]').forEach(function (input) {
        input.value = variant.id;
      });
      document.querySelectorAll('[data-mb-pdp-price], [data-mb-pdp-sticky-price]').forEach(function (el) {
        el.textContent = formatMoney(variant.price);
      });
      document.querySelectorAll('[data-mb-pdp-sku]').forEach(function (el) {
        var prefix = el.getAttribute('data-prefix') || '';
        if (variant.sku) {
          el.textContent = (prefix ? prefix + ' ' : '') + variant.sku;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      document.querySelectorAll('[data-mb-pdp-avail]').forEach(function (wrap) {
        var inEl = wrap.querySelector('[data-mb-pdp-avail-in]');
        var outEl = wrap.querySelector('[data-mb-pdp-avail-out]');
        if (inEl) inEl.hidden = !variant.available;
        if (outEl) outEl.hidden = variant.available;
      });
      document.querySelectorAll('[data-mb-pdp-atc-button]').forEach(function (btn) {
        btn.disabled = !variant.available;
        setAtcButtonLabel(btn, variant.available ? btn.getAttribute('data-label') : btn.getAttribute('data-sold-out-label'));
      });
      applyVariantImage(variant);
    }

    function markUnavailableCombo() {
      document.querySelectorAll('[data-mb-pdp-atc-button]').forEach(function (btn) {
        btn.disabled = true;
        setAtcButtonLabel(btn, btn.getAttribute('data-sold-out-label'));
      });
    }

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mb-pdp-variant-value]');
      if (!btn) return;

      var pos = parseInt(btn.getAttribute('data-option-position'), 10);
      var row = btn.closest('[data-mb-pdp-variant-option]');
      row.querySelectorAll('[data-mb-pdp-variant-value]').forEach(function (b) {
        var isThis = b === btn;
        b.classList.toggle('is-selected', isThis);
        b.setAttribute('aria-pressed', isThis ? 'true' : 'false');
      });
      var curEl = row.querySelector('[data-mb-pdp-current-value]');
      if (curEl) curEl.textContent = btn.getAttribute('data-value');
      selected[pos - 1] = btn.getAttribute('data-value');

      var variant = findVariant();
      if (variant) {
        apply(variant);
      } else {
        markUnavailableCombo();
      }
    });
  });

  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var active = btn.getAttribute('data-active') === 'true';
      btn.setAttribute('data-active', active ? 'false' : 'true');
      btn.setAttribute('aria-pressed', active ? 'false' : 'true');
    });
  });

  document.querySelectorAll('[data-mb-pdp-sticky-bar]').forEach(function (bar) {
    var triggerSelector = bar.getAttribute('data-trigger-selector');
    var trigger = triggerSelector ? document.querySelector(triggerSelector) : null;

    // Move the bar to be a direct child of <body>. Shopify/Horizon sections
    // are sometimes wrapped in elements with a CSS transform (scroll-reveal
    // animations), and any ancestor with a transform traps position:fixed
    // children so they stop sticking to the viewport. Re-parenting to body
    // guarantees it's fixed relative to the real viewport. This theme loads
    // each page as a real, full navigation (no soft/morph transition), so
    // the old DOM — including this appended bar — is discarded automatically
    // on every navigation; no manual cross-page cleanup is needed here, and
    // watching #MainContent for unrelated mutations (e.g. an app's async
    // widget render) risked removing the bar on the SAME page by mistake.
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    if (trigger) {
      // getBoundingClientRect() always reflects the trigger's true position
      // relative to the viewport no matter which element is actually
      // scrolling, but the listener has to be attached to whichever element
      // that actually is. At narrower widths this theme leaves body/html
      // scrollable (window fires 'scroll'); at wider desktop widths it
      // switches body/html to overflow:hidden and makes .page-wrapper (an
      // ancestor several levels up) the real scrolling element instead, so
      // window never fires 'scroll' there. Listening on both covers either case.
      var ticking = false;
      var update = function () {
        ticking = false;
        var rect = trigger.getBoundingClientRect();
        bar.classList.toggle('show', rect.bottom < 90);
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      };
      var pageScroller = document.querySelector('.page-wrapper');
      window.addEventListener('scroll', onScroll, { passive: true });
      if (pageScroller) pageScroller.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    var qtyInput = bar.querySelector('[data-mb-pdp-sticky-qty]');
    var mainQtyValue = document.querySelector('[data-mb-pdp-qty-value]');
    var form = bar.querySelector('form');
    if (qtyInput && mainQtyValue && form) {
      form.addEventListener('submit', function () {
        qtyInput.value = mainQtyValue.textContent.trim() || '1';
      });
    }
  });
});
